import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import toastr from 'toastr';


import {getCurrentUserId, getCurrentUserName, getJwt} from '../../../services/authService';
// import ReactGA from 'react-ga';
import http from '../../../services/httpService';
import AddFundsStep1 from './AddFundsStep1';

// import AddFundsStep1 from './AddFundsStep1';
import AddFundsStep2 from './AddFundsStep2';
import AddFundsStep3 from './AddFundsStep3';
import OrderSummary from './OrderSummary';
import RetinaImage from "react-retina-image";
import ViberSelectPlan from './ViberSelectPlan';

//import {StripeProvider} from 'react-stripe-elements';


class AddFunds extends Component {

    state = {
        activeStep: 2,
        payPhoneNumbers: false,
        loader: false,
        fundsAmount: 20,
        creditsSelector: 1000,
        creditsAmount: 1000,
        companyName: '',
        billingName: '',
        address1: '',
        address2: '',
        postalCode: '',
        city: '',
        country: '',
        usState: '',
        vatNumber: '',
        poNumber: '',
        phone: {
            iso2: 'us',
            dialCode: '1',
            phone: ''
        },
        amount: '',
        stripePlanId: '',
        userDataLoaded: false,
        addedNumbers: [],
        yearlySubscription: false,
        freeTrial: false,
        shouldAddVat: false,
        discountedAmount: this.props.discountedAmount ? this.props.discountedAmount : '',
        upcomingSwitchPlans: '',
        hasExistingPaymentMethod: true,
        viberSelectedPlan: ''
    };


    loadingSubscribers = (loading) => {
        // console.log('loading in main js:', loading);
        this.setState({
            loadingPostReach: loading
        });
        //console.log('loading subscribers in modal:', this.state.loadingPostReach)
    };

    addSource = (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: '+ New Feed',
        //     label: '',
        //     userId: getCurrentUserId(),
        //     nonInteraction: true
        // });
        this.props.history.push('/workspace-name');
    };


    analytics = () => {
        //  ReactGA.set({userId: getCurrentUserId()});
        //  ReactGA.pageview(window.location.pathname + window.location.search);
    };

    async componentDidMount() {
        // ReactGA.initialize('UA-90436832-5', {
        //     debug: false,
        //     titleCase: false,
        //     gaOptions: {
        //         userId: getCurrentUserId()
        //     }
        // });

        this.analytics();
        // console.log('cdm - location.state: ', this.props.location.state);

        const user_id = await getCurrentUserId();
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = await this.props.user;
        let project = await user && user.sources.length ? user.sources.data.find(source => source.id.toString() === projectId) : '';
        //let sharedProject = await user && user.feeds_shared && user.feeds_shared.data && user.feeds_shared.data.length ? user.feeds_shared.data.find(feed => feed.id.toString() === projectId) : '';
        let billingName = await user ? user.name : '';
        let companyName = await project ? project.name :
            //sharedProject ? sharedProject.name :
            '';
        let email = await user ? user.email : '';
        let phone = await user ? user.phone : '';
        await this.setState({billingName, companyName, email, phone})
        if (this.props.location.state && this.props.location.state.amount && this.props.location.state.stripePlanId) {
            // console.log('AddFunds stripePlanId: ',this.props.location.state.amount, this.props.location.state.stripePlanId )
            let yearlySubscription = await false;
            if (this.props.location.state.planPeriod && (this.props.location.state.planPeriod === 'yearly')) {
                yearlySubscription = await true
            }
            ;
            let upcomingSwitchPlans = '';
            if (this.props.location.state.upcomingSwitchPlans) {
                upcomingSwitchPlans = await this.props.location.state.upcomingSwitchPlans;
            }
            await this.setState({
                fundsAmount: this.props.location.state.amount,
                stripePlanId: this.props.location.state.stripePlanId,
                yearlySubscription,
                discountedAmount: this.props.location.state.discountedAmount ? this.props.location.state.discountedAmount : '',
                upcomingSwitchPlans

            })
        }
        if (this.props.location.state && this.props.location.state.freeTrial && (window.location.pathname === '/add-funds/billing-details' || window.location.pathname === '/add-funds/payment')) {
            // console.log('Add Funds - setting free trial to true')
            await this.setState({freeTrial: this.props.location.state.freeTrial || false})
        }
        if ((window.location.pathname === '/viber-subscription/billing-details' || window.location.pathname === '/viber-subscription/payment')) {
            // console.log('Add Funds - setting free trial to true')
            if (this.props.location.state && this.props.location.state.planType) {
                let fundsAmount = this.props.location.state.planType === 'Region A' ? 200 : 150
                await this.setState({viberSelectedPlan: this.props.location.state.planType || '', fundsAmount})
            } else {
                this.props.history.push('/viber-subscription/select-plan')
            }
        }
        if (!user_id && (window.location.pathname !== "/login" && window.location.pathname !== "/register")) {
            window.location = "/login";
        }
        if (window.location.pathname === '/pay-phone-numbers') {
            await this.props.history.push('/pay-phone-numbers/billing-details')
            await this.setState({
                payPhoneNumbers: true,
                fundsAmount: this.props.location.state.amount,
                addedNumbers: this.props.location.state.addedNumbers,
            })
        } else if ((window.location.pathname === '/pay-phone-numbers/billing-details') || (window.location.pathname === '/pay-phone-numbers/payment')) {
            if (this.props.location.state && this.props.location.state.amount && this.props.location.state.addedNumbers && this.props.location.state.addedNumbers.length) {
                await this.setState({
                    payPhoneNumbers: true,
                    fundsAmount: this.props.location.state.amount,
                    addedNumbers: this.props.location.state.addedNumbers
                })
            } else {
                await this.props.history.push('/channels')
            }
        } else if (((window.location.pathname === '/add-funds/billing-details') || (window.location.pathname === '/add-funds/payment')) && !this.state.fundsAmount) {
            await this.props.history.push('/add-funds/billing-details')
            // this.props.history.push('/add-funds/enter-amount')
        }else if(window.location.pathname === '/top-up/add-credits'){
            await this.updateCreditsAmount(1000, 1000);
            await this.setState({
                activeStep: 1,
            })
            if (this.props.location.state && this.props.location.state.amount) {
                await this.setState({fundsAmount: this.props.location.state.amount})
            }
            if (user && user.customer) {
                /*GET PAYMENT METHODS PROJECT*/
                try {
                    const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                    let projectPaymentMethods = await result && result.data && result.data.project_payment_methods ? result.data.project_payment_methods : [];
                    let userPaymentMethods = await result && result.data && result.data.user_payment_methods ? result.data.user_payment_methods : [];
                    // console.log('payment methods: ', projectPaymentMethods, userPaymentMethods)
                    if ((userPaymentMethods && (userPaymentMethods.length > 0) && (userPaymentMethods[0].payment_method_id)) ||
                        (projectPaymentMethods && (projectPaymentMethods.length > 0) && (projectPaymentMethods[0].payment_method_id))
                    ) {
                        await this.setState({hasExistingPaymentMethod: true})
                    } else {
                        await this.setState({hasExistingPaymentMethod: false})
                    }

                } catch (ex) {
                    toastr.error("Error Code #99036: Couldn't receive payment methods, please try again.");
                }

            } else if (user && !user.customer) {
                let userId = await user.id || getCurrentUserId();
                try {
                    const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer', {}, {headers: {authorization: getJwt()}})
                    // console.log('Evo rezultata za create stripe customer: ', stripeResult)
                } catch (ex) {
                    await toastr.error("Error Code #99037: Stripe customer was not created, please try again.");
                    await this.props.updateUserFromServer();
                }
            }
        } else if (window.location.pathname === '/viber-subscription/select-plan') {
            await this.setState({
                activeStep: 1,
            })
            if (this.props.location.state && this.props.location.state.planType) {
                let fundsAmount = this.props.location.state.planType === 'Region A' ? 200 : 150
                await this.setState({viberSelectedPlan: this.props.location.state.planType || '', fundsAmount})
            }
            if (user && user.customer) {
                /*GET PAYMENT METHODS PROJECT*/
                try {
                    const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                    let projectPaymentMethods = await result && result.data && result.data.project_payment_methods ? result.data.project_payment_methods : [];
                    let userPaymentMethods = await result && result.data && result.data.user_payment_methods ? result.data.user_payment_methods : [];
                    // console.log('payment methods: ', projectPaymentMethods, userPaymentMethods)
                    if ((userPaymentMethods && (userPaymentMethods.length > 0) && (userPaymentMethods[0].payment_method_id)) ||
                        (projectPaymentMethods && (projectPaymentMethods.length > 0) && (projectPaymentMethods[0].payment_method_id))
                    ) {
                        await this.setState({hasExistingPaymentMethod: true})
                    } else {
                        await this.setState({hasExistingPaymentMethod: false})
                    }

                } catch (ex) {
                    toastr.error("Error Code #99038: Couldn't receive payment methods, please try again.");
                }
            }

        }
    }

    componentDidUpdate() {
        let projectId = this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let user = this.props.user;
        let project = user && user.sources && user.sources.data && user.sources.data.length ? user.sources.data.find(source => source.id.toString() === projectId.toString()) : '';
        //let sharedProject = user && user.feeds_shared && user.feeds_shared.data && user.feeds_shared.data.length ? user.feeds_shared.data.find(feed => feed.id.toString() === projectId.toString()) : '';
        let companyName = project ? project.name :
            //sharedProject ? sharedProject.name :
            '';
        if (user && user.name && !this.state.billingName && !this.state.userDataLoaded) {
            let billingName = user ? user.name : '';
            let email = user ? user.email : '';
            let phone = user ? user.phone : '';
            this.setState({billingName, companyName, email, phone, userDataLoaded: true})
            // console.log('Evo ga state: ', projectId, user, billingName, companyName, email)
        }
        // if(companyName && !this.state.companyName && !this.state.userDataLoaded){
        //     this.setState({companyName, userDataLoaded: true})
        // }

    }

    handleStepChange = (step) => {
        // console.log('handleStepChange: ', step)
        this.setState({activeStep: step})
        this.props.history.push('/add-funds/' + step === 1 ? 'enter-amount' : step === 2 ? 'billing-details' : 'payment')
    }

    handleTopUpStepChange = (step) => {
        this.setState({activeStep: step})
        if(this.state.hasExistingPaymentMethod){
            if(step === 2){
                this.props.history.push('/topup-existing-payment',{
                    amount: this.state.fundsAmount,
                    creditsAmount: this.state.creditsSelector !== 'Custom' ? this.state.creditsSelector : this.state.creditsAmount
                });
            } else if( step === 1){
                this.props.history.push('/top-up/add-credits');
            }
        }else{
            this.props.history.push('/top-up/' + step === 1 ? 'add-credits' : step === 2 ? 'billing-details' : 'payment')
        }
    }

    handleViberStepChange = (step) => {
        this.setState({activeStep: step})
        if (this.state.hasExistingPaymentMethod) {
            if (step === 2) {
                this.props.history.push('/viber-subscription-existing-payment', {
                    viberSelectedPlan: this.state.viberSelectedPlan
                });
            } else if (step === 1) {
                this.props.history.push('/viber-subscription/add-funds');
            }
        } else {
            this.props.history.push('/viber-subscription/' + step === 1 ? 'select-plan' : step === 2 ? 'billing-details' : 'payment')
        }
    }

    updateFundsAmount = async (value) => {
        await this.setState({fundsAmount: value})
    }

    updateCreditsAmount = (creditsSelector, creditsAmount) => {
        let creditPrice = this.props.selectedSourceNode && this.props.selectedSourceNode.plan && this.props.selectedSourceNode.plan.platform_limits
                && this.props.selectedSourceNode.plan.platform_limits.sms && this.props.selectedSourceNode.plan.platform_limits.sms.price || '';
        this.setState({
            creditsSelector,
            creditsAmount,
            fundsAmount: creditsSelector !== 'Custom' ? (parseInt(creditsSelector) * creditPrice) : (parseInt(creditsAmount) * creditPrice)
        })

        // console.log('updateCreditsAmount: ', this.state.creditsSelector, this.state.creditsAmount, this.state.fundsAmount)
    }

    updateSelectPlan = (value) => {
        let fundsAmount = value === 'Region A' ? 200 : 150
        this.setState({
            viberSelectedPlan: value,
            fundsAmount
        })
    }

    updateBillingDetails = (name, value) => {
        // console.log('Evo detalja: ', name, value)
        this.setState({
            [name]: value
        })
        // this.setState({
        //     companyName: details.companyName,
        //     billingName: details.billingName,
        //     address1: details.address1,
        //     address2: details.address2,
        //     postalCode: details.postalCode,
        //     phone: details.phone,
        //     email: details.email,
        //     city: details.city,
        //     country: details.country,
        //     usState: details.usState,
        //     vatNumber: details.vatNumber,
        //     poNumber: details.poNumber,
        //     shouldAddVat: details.shouldAddVat
        // })
        // console.log('Evo state-a: ', this.state)
    }

    render() {
        return (
            <div className="add-funds-wrapper">
                <div className="top-navigation">
                    <RetinaImage src={['/img/emitto-logo.png', '/img/emitto-logo.svg']} checkIfRetinaImgExists={false}/>
                    {this.state.payPhoneNumbers ?
                        <div className="navigation-wrapper">
                            {this.state.activeStep === 1 ?
                                <i className="fas fa-chevron-right"></i>
                                :
                                <i className="fas fa-check"></i>
                            }
                            <div className="menu-link">
                                <NavLink to="/phone-numbers">
                                    <span
                                        className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Phone
                                        Numbers</span>
                                </NavLink>
                            </div>
                            {(this.state.activeStep === 1) || (this.state.activeStep === 2) ?
                                <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>
                                :
                                <i className="fas fa-check"></i>
                            }
                            <div className="menu-link">
                                <NavLink to="/pay-phone-numbers/billing-details"
                                         onClick={() => this.handleStepChange(2)}>
                                    <span
                                        className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                        Details</span>
                                </NavLink>
                            </div>
                            <i className={(this.state.activeStep === 3) ? "fas fa-chevron-right" : "fas fa-chevron-right grey-text"}></i>
                            <div className="menu-link">
                                {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                {/*</NavLink>*/}
                            </div>
                        </div>
                        :
                        (window.location.pathname === '/add-funds/billing-details') || (window.location.pathname === '/add-funds/payment') ?
                            <div className="navigation-wrapper">
                                {this.state.activeStep === 1 ?
                                    <i className="fas fa-chevron-right"></i>
                                    :
                                    <i className="fas fa-check"></i>
                                }
                                <div className="menu-link">
                                    <NavLink to="/subscription-plans" onClick={() => this.handleStepChange(1)}>
                                        <span
                                            className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Choose
                                            Plan</span>
                                    </NavLink>
                                </div>
                                {(this.state.activeStep === 1) || (this.state.activeStep === 2) ?
                                    <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>
                                    :
                                    <i className="fas fa-check"></i>
                                }
                                <div className="menu-link">
                                    <NavLink to="/add-funds/billing-details" onClick={() => this.handleStepChange(2)}>
                                        <span
                                            className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                            Details</span>
                                    </NavLink>
                                </div>
                                <i className={(this.state.activeStep === 3) ? "fas fa-chevron-right" : "fas fa-chevron-right grey-text"}></i>
                                <div className="menu-link">
                                    {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                    <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                    {/*</NavLink>*/}
                                </div>
                            </div>
                            :
                            (window.location.pathname === '/viber-subscription/select-plan') ||
                            (window.location.pathname === '/viber-subscription/billing-details') ||
                            (window.location.pathname === '/viber-subscription/payment') ?
                                this.state.hasExistingPaymentMethod ?
                                    <div className="navigation-wrapper">
                                        <i className="fas fa-chevron-right"></i>
                                        <div className="menu-link">
                                            <NavLink to="/channels/viber">
                                                <span
                                                    className='regular'>Back to Channels</span>
                                            </NavLink>
                                        </div>
                                        {this.state.activeStep === 1 ?
                                            <i className="fas fa-chevron-right"></i>
                                            :
                                            <i className="fas fa-check"></i>
                                        }
                                        <div className="menu-link">
                                            <NavLink to="/viber-subscription/select-plan"
                                                     onClick={() => this.handleStepChange(1)}>
                                                <span className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Select
                                                    Plan</span>
                                            </NavLink>
                                        </div>

                                        <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>
                                        <div className="menu-link">
                                            {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                            <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                            {/*</NavLink>*/}
                                        </div>
                                    </div>
                                    :
                                    <div className="navigation-wrapper">

                                        <i className="fas fa-chevron-right"></i>
                                        <div className="menu-link">
                                            <NavLink to="/channels/viber">
                                                <span
                                                    className='regular'>Back to Channels</span>
                                            </NavLink>
                                        </div>
                                        {this.state.activeStep === 1 ?
                                            <i className="fas fa-chevron-right"></i>
                                            :
                                            <i className="fas fa-check"></i>
                                        }
                                        <div className="menu-link">
                                            <NavLink to="/viber-subscription/select-plan"
                                                     onClick={() => this.handleStepChange(1)}>
                                                <span
                                                    className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Select
                                                    Plan</span>
                                            </NavLink>
                                        </div>
                                        {(this.state.activeStep === 3) ?
                                            <i className="fas fa-check"></i>
                                            :
                                            <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>

                                        }
                                        <div className="menu-link">
                                            {(this.state.activeStep === 3) ?
                                                <NavLink to="/viber-subscription/billing-details"
                                                         onClick={() => this.handleStepChange(2)}>
                                                    <span
                                                        className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                                        Details</span>
                                                </NavLink>
                                                :
                                                <span
                                                    className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                                    Details</span>
                                            }
                                        </div>
                                        <i className={(this.state.activeStep === 3) ? "fas fa-chevron-right" : "fas fa-chevron-right grey-text"}></i>
                                        <div className="menu-link">
                                            {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                            <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                            {/*</NavLink>*/}
                                        </div>
                                    </div>
                                :
                                this.state.hasExistingPaymentMethod ?
                                    <div className="navigation-wrapper">
                                        <i className="fas fa-chevron-right"></i>
                                        <div className="menu-link">
                                            <NavLink to="/billing/balance">
                                                <span
                                                    className='regular'>Back to Balance</span>
                                            </NavLink>
                                        </div>
                                        {/*{this.state.activeStep === 1 ?*/}
                                        {/*    <i className="fas fa-chevron-right"></i>*/}
                                        {/*    :*/}
                                        {/*    <i className="fas fa-check"></i>*/}
                                        {/*}*/}
                                        {/*<div className="menu-link">*/}
                                        {/*    <NavLink to="/billing/balance">*/}
                                        {/*        <span*/}
                                        {/*            className='regular'>Back to Balance</span>*/}
                                        {/*    </NavLink>*/}
                                        {/*</div>*/}
                                        {this.state.activeStep === 1 ?
                                            <i className="fas fa-chevron-right"></i>
                                            :
                                            <i className="fas fa-check"></i>
                                        }
                                        <div className="menu-link">
                                            <NavLink to="/top-up/add-credits" onClick={() => this.handleStepChange(1)}>
                                            <span
                                                className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Add Credits</span>
                                            </NavLink>
                                        </div>

                                        <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>
                                        <div className="menu-link">
                                            {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                            <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                            {/*</NavLink>*/}
                                        </div>
                                    </div>
                                    :
                                    <div className="navigation-wrapper">

                                        <i className="fas fa-chevron-right"></i>
                                        <div className="menu-link">
                                            <NavLink to="/billing/balance">
                                                <span
                                                    className='regular'>Back to Balance</span>
                                            </NavLink>
                                        </div>
                                        {this.state.activeStep === 1 ?
                                            <i className="fas fa-chevron-right"></i>
                                            :
                                            <i className="fas fa-check"></i>
                                        }
                                        <div className="menu-link">
                                            <NavLink to="/top-up/add-funds" onClick={() => this.handleStepChange(1)}>
                                                <span
                                                    className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Add
                                                    Funds</span>
                                            </NavLink>
                                        </div>
                                        {(this.state.activeStep === 3) ?
                                            <i className="fas fa-check"></i>
                                            :
                                            <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>

                                        }
                                        <div className="menu-link">
                                            {(this.state.activeStep === 3) ?
                                                <NavLink to="/top-up/billing-details"
                                                         onClick={() => this.handleStepChange(2)}>
                                                    <span
                                                        className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                                        Details</span>
                                                </NavLink>
                                                :
                                                <span
                                                    className={this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular'}>Billing
                                                    Details</span>
                                            }
                                            <div className="menu-link">
                                                <NavLink to="/top-up/add-credits" onClick={() => this.handleStepChange(1)}>
                                                    <span
                                                        className={this.state.activeStep === 1 ? 'blue' : 'regular'}>Add Credits</span>
                                                </NavLink>
                                            </div>
                                            {(this.state.activeStep === 3) ?
                                                <i className="fas fa-check"></i>
                                                :
                                                <i className={(this.state.activeStep === 1) ? "fas fa-chevron-right grey-text" : "fas fa-chevron-right"}></i>

                                            }
                                            <div className="menu-link">
                                                { (this.state.activeStep === 3) ?
                                                    <NavLink to="/top-up/billing-details" onClick={ () => this.handleStepChange(2) }>
                                                        <span
                                                            className={ this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular' }>Billing
                                                            Details</span>
                                                    </NavLink>
                                                    :
                                                    <span
                                                        className={ this.state.activeStep === 1 ? 'grey' : this.state.activeStep === 2 ? 'blue' : 'regular' }>Billing
                                                            Details</span>
                                                }
                                            </div>
                                            <i className={(this.state.activeStep === 3) ? "fas fa-chevron-right" : "fas fa-chevron-right grey-text"}></i>
                                            <div className="menu-link">
                                                {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                                <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                                {/*</NavLink>*/}
                                            </div>
                                        </div>
                                        <i className={(this.state.activeStep === 3) ? "fas fa-chevron-right" : "fas fa-chevron-right grey-text"}></i>
                                        <div className="menu-link">
                                            {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                                            <span className={this.state.activeStep < 3 ? 'grey' : 'blue'}>Payment</span>
                                            {/*</NavLink>*/}
                                        </div>
                                    </div>
                    }

                </div>

                <div className="main">

                    {/*Router starts*/}
                    <Switch>
                        <Route path="/add-funds/billing-details"
                               render={(props) => <AddFundsStep2
                                   user={this.props.user}
                                   handleStepChange={this.handleStepChange}
                                   updateBillingDetails={this.updateBillingDetails}
                                   companyName={this.state.companyName}
                                   billingName={this.state.billingName}
                                   address1={this.state.address1}
                                   address2={this.state.address2}
                                   postalCode={this.state.postalCode}
                                   phone={this.state.phone}
                                   email={this.state.email}
                                   city={this.state.city}
                                   country={this.state.country}
                                   usState={this.state.usState}
                                   vatNumber={this.state.vatNumber}
                                   poNumber={this.state.poNumber}
                                   fundsAmount={this.state.fundsAmount}
                                   shouldAddVat={this.state.shouldAddVat}
                                   {...props}/>
                               }/>
                        <Route path="/add-funds/payment"
                               render={(props) => <AddFundsStep3
                                   user={this.props.user}
                                   handleStepChange={this.handleStepChange}
                                   billingDetails={{
                                       company_name: this.state.companyName,
                                       phone: this.state.phone,
                                       email: this.state.email,
                                       billing_name: this.state.billingName,
                                       vat_number: this.state.vatNumber,
                                       po_number: this.state.poNumber,
                                       address: {
                                           city: this.state.city,
                                           country: this.state.country,
                                           line1: this.state.address1,
                                           postal_code: this.state.postalCode,
                                           state: this.state.usState && (this.state.usState !== 'Select State') ? this.state.usState : ''
                                       }
                                   }}
                                   fundsAmount={this.state.fundsAmount}
                                   stripePlanId={this.state.stripePlanId}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   freeTrial={this.state.freeTrial}
                                   updateUpcomingSwitchPlans={upcomingSwitchPlans => this.setState({upcomingSwitchPlans})}
                                   {...props}/>
                               }/>
                        <Route path="/pay-phone-numbers/billing-details"
                               render={(props) => <AddFundsStep2
                                   user={this.props.user}
                                   handleStepChange={this.handleStepChange}
                                   updateBillingDetails={this.updateBillingDetails}
                                   companyName={this.state.companyName}
                                   billingName={this.state.billingName}
                                   address1={this.state.address1}
                                   address2={this.state.address2}
                                   postalCode={this.state.postalCode}
                                   phone={this.state.phone}
                                   email={this.state.email}
                                   city={this.state.city}
                                   country={this.state.country}
                                   usState={this.state.usState}
                                   vatNumber={this.state.vatNumber}
                                   poNumber={this.state.poNumber}
                                   fundsAmount={this.state.fundsAmount}
                                   shouldAddVat={this.state.shouldAddVat}
                                   {...props}/>
                               }/>
                        <Route path="/pay-phone-numbers/payment"
                               render={(props) => <AddFundsStep3
                                   user={this.props.user}
                                   handleStepChange={this.handleStepChange}
                                   billingDetails={{
                                       company_name: this.state.companyName,
                                       phone: this.state.phone,
                                       email: this.state.email,
                                       billing_name: this.state.billingName,
                                       vat_number: this.state.vatNumber,
                                       po_number: this.state.poNumber,
                                       address: {
                                           city: this.state.city,
                                           country: this.state.country,
                                           line1: this.state.address1,
                                           postal_code: this.state.postalCode,
                                           state: this.state.usState && (this.state.usState !== 'Select State') ? this.state.usState : ''
                                       }
                                   }}
                                   fundsAmount={this.state.fundsAmount}
                                   stripePlanId={this.state.stripePlanId}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   addedNumbers={this.state.addedNumbers}
                                   updateUpcomingSwitchPlans={upcomingSwitchPlans => this.setState({upcomingSwitchPlans})}
                                   {...props}/>
                               }/>
                        <Route path="/top-up/add-credits"
                               render={(props) => <AddFundsStep1
                                   user={this.props.user}
                                   handleStepChange={this.handleTopUpStepChange}
                                   // updateFundsAmount={this.updateFundsAmount}
                                   // fundsAmount={this.state.fundsAmount}
                                   creditsSelector={this.state.creditsSelector}
                                   creditsAmount={this.state.creditsAmount}
                                   updateCreditsAmount={this.updateCreditsAmount}
                                   {...props}/>
                               }/>
                        <Route path="/top-up/billing-details"
                               render={(props) => <AddFundsStep2
                                   user={this.props.user}
                                   handleStepChange={this.handleTopUpStepChange}
                                   updateBillingDetails={this.updateBillingDetails}
                                   companyName={this.state.companyName}
                                   billingName={this.state.billingName}
                                   address1={this.state.address1}
                                   address2={this.state.address2}
                                   postalCode={this.state.postalCode}
                                   phone={this.state.phone}
                                   email={this.state.email}
                                   city={this.state.city}
                                   country={this.state.country}
                                   usState={this.state.usState}
                                   vatNumber={this.state.vatNumber}
                                   poNumber={this.state.poNumber}
                                   fundsAmount={this.state.fundsAmount}
                                   shouldAddVat={this.state.shouldAddVat}
                                   {...props}/>
                               }/>
                        <Route path="/top-up/payment"
                               render={(props) => <AddFundsStep3
                                   user={this.props.user}
                                   handleStepChange={this.handleTopUpStepChange}
                                   billingDetails={{
                                       company_name: this.state.companyName,
                                       phone: this.state.phone,
                                       email: this.state.email,
                                       billing_name: this.state.billingName,
                                       vat_number: this.state.vatNumber,
                                       po_number: this.state.poNumber,
                                       address: {
                                           city: this.state.city,
                                           country: this.state.country,
                                           line1: this.state.address1,
                                           postal_code: this.state.postalCode,
                                           state: this.state.usState && (this.state.usState !== 'Select State') ? this.state.usState : ''
                                       }
                                   }}
                                   fundsAmount={this.state.fundsAmount}
                                   stripePlanId={this.state.stripePlanId}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   freeTrial={this.state.freeTrial}
                                   updateUpcomingSwitchPlans={upcomingSwitchPlans => this.setState({upcomingSwitchPlans})}
                                   topUpViber={true}
                                   {...props}/>
                               }/>
                        <Route path="/viber-subscription/select-plan"
                               render={(props) => <ViberSelectPlan
                                   user={this.props.user}
                                   handleStepChange={this.handleViberStepChange}
                                   updateSelectPlan={this.updateSelectPlan}
                                   fundsAmount={this.state.fundsAmount}
                                   selectedPlan={this.state.viberSelectedPlan}
                                   {...props}/>
                               }/>
                        <Route path="/viber-subscription/billing-details"
                               render={(props) => <AddFundsStep2
                                   user={this.props.user}
                                   handleStepChange={this.handleViberStepChange}
                                   updateBillingDetails={this.updateBillingDetails}
                                   companyName={this.state.companyName}
                                   billingName={this.state.billingName}
                                   address1={this.state.address1}
                                   address2={this.state.address2}
                                   postalCode={this.state.postalCode}
                                   phone={this.state.phone}
                                   email={this.state.email}
                                   city={this.state.city}
                                   country={this.state.country}
                                   usState={this.state.usState}
                                   vatNumber={this.state.vatNumber}
                                   poNumber={this.state.poNumber}
                                   fundsAmount={this.state.fundsAmount}
                                   shouldAddVat={this.state.shouldAddVat}
                                   {...props}/>
                               }/>
                        <Route path="/viber-subscription/payment"
                               render={(props) => <AddFundsStep3
                                   user={this.props.user}
                                   handleStepChange={this.handleViberStepChange}
                                   billingDetails={{
                                       company_name: this.state.companyName,
                                       phone: this.state.phone,
                                       email: this.state.email,
                                       billing_name: this.state.billingName,
                                       vat_number: this.state.vatNumber,
                                       po_number: this.state.poNumber,
                                       address: {
                                           city: this.state.city,
                                           country: this.state.country,
                                           line1: this.state.address1,
                                           postal_code: this.state.postalCode,
                                           state: this.state.usState && (this.state.usState !== 'Select State') ? this.state.usState : ''
                                       }
                                   }}
                                   fundsAmount={this.state.fundsAmount}
                                   stripePlanId={this.state.stripePlanId}
                                   updateUserFromServer={this.props.updateUserFromServer}
                                   freeTrial={this.state.freeTrial}
                                   updateUpcomingSwitchPlans={upcomingSwitchPlans => this.setState({upcomingSwitchPlans})}
                                   // topUpViber={true}
                                   viberPlan={this.state.viberSelectedPlan}
                                   {...props}/>
                               }/>
                    </Switch>
                    <OrderSummary
                        orderAmount={this.state.fundsAmount}
                        vat={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) * 0.2 : 0}
                        totalAmount={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) + (parseInt(this.state.fundsAmount) * 0.2) : this.state.fundsAmount}
                        exclVat={0}
                        newBalance={this.state.fundsAmount}
                        withCheckout={this.state.addedNumbers.length}
                        cartListTitle={'Phone Numbers'}
                        cartListSubtitle={'Monthly Subscription'}
                        cartList={this.state.addedNumbers}
                        cartItemIdentifier={this.state.addedNumbers.length ? 'phoneNumber' : ''}
                        cartCostIdentifier={this.state.addedNumbers.length ? 'base_price' : ''}
                        disableItemRemoval={true}
                        stripePlanId={this.state.stripePlanId ? this.state.stripePlanId : ''}
                        yearlySubscription={this.state.yearlySubscription}
                        noButton={true}
                        spinner={this.state.spinnerActive}
                        discountedAmount={this.state.discountedAmount}
                        discountAmount={this.state.upcomingSwitchPlans && this.state.upcomingSwitchPlans.invoiceEstimate &&
                        this.state.upcomingSwitchPlans.invoiceEstimate.lineItems && this.state.upcomingSwitchPlans.invoiceEstimate.lineItems.length &&
                        this.state.upcomingSwitchPlans.invoiceEstimate.lineItems[0].discountAmount ? this.state.upcomingSwitchPlans.invoiceEstimate.lineItems[0].discountAmount / 100 : ''
                        }
                        upcomingSwitchPlans={this.state.upcomingSwitchPlans}
                        topUpActive={(window.location.pathname === '/top-up/add-funds') || (window.location.pathname === '/top-up/billing-details') ||
                        (window.location.pathname === '/top-up/payment') ? true : false}
                        previousCredit={this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance && this.props.selectedSourceNode.project_balance.credits ?
                            parseInt(this.props.selectedSourceNode.project_balance.credits).toFixed(2) : ''}
                        creditsAmount={this.state.creditsSelector !== 'Custom' ? this.state.creditsSelector : this.state.creditsAmount}
                        viberSubscriptionSelected={this.state.viberSelectedPlan && this.state.activeStep === 1 ? this.state.viberSelectedPlan : ''}
                        showViberPlanName={this.state.viberSelectedPlan}
                        handleSubmit={this.state.viberSelectedPlan ? () => this.handleViberStepChange(2) : ''}
                    />
                </div>
            </div>
        );
    }
}

export default AddFunds;